import { PassTargetTypeEnum } from '../../enums';

export interface PassTargetInterface {
  id?: string;
  passId?: string;
  targetId?: string;
  targetType?: PassTargetTypeEnum;
}
